// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__s1Dxh {
    --page-top-offset: 46px;
    display: flex;
    flex-direction: column;
    margin: var(--container-margin) auto;
    width: var(--container-width);
    max-width: 100%;
    padding: 0 var(--container-padding) 60px;
    /*max-height: calc(100vh - var(--header-height));*/
}

.styles_content__Pcba\\+ {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    /*padding: 0 0 60px;*/
}

.styles_content__Pcba\\+ .styles_twoColumnLayout__xGVzJ {
    align-items: flex-start;
    width: 100%;
}

.styles_content__Pcba\\+ h3 {
    font-weight: 300;
    font-size: 20px;
}

.styles_dropzoneContainer__6uBNK {
    display: flex;
    padding: 22px 17px 22px;
    flex-direction: column;
    /*gap: 40px;*/
    border: 0.5px solid var(--dark-grey);
    background-color: rgba(240, 243, 247, 0.1);
    width: 950px;
    max-width: 100%;
    border-radius: 3px;
    box-sizing: border-box;
    position: relative;
}

.styles_dropzoneContainerWide__C0V5J {
    min-height: 300px;
    padding-bottom: 10px;
}

.styles_dropzoneContainer__6uBNK.styles_active__lgxyy {
    background-color: rgba(240, 243, 247, 0.2);
}

.styles_actionBtn__CzTzm {
    position: absolute;
    top: -17px;
    right: -17px;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: #fff;
    border: 1px solid var(--dark-grey);
    display: flex;
    justify-content: center;
    align-items: center;
    --icon-color-custom: var(--dark-grey);
    transition:
        background-color 0.4s,
        border-color 0.4s;
    padding: 0;
    z-index: 2;
}

.styles_actionBtn__CzTzm.styles_active__lgxyy {
    --icon-color-custom: var(--primary-color);
    border-color: var(--primary-color);
}

.styles_actionBtn__CzTzm:hover,
.styles_actionBtn__CzTzm.styles_active__lgxyy:hover {
    --icon-color-custom: #fff;
    border-color: var(--primary-color);
    background-color: var(--primary-color);
}

.styles_fileList__2xPJa {
    /*display: grid;*/
    /*grid-template-columns: repeat(3, 1fr);*/
    gap: 16px;
    margin-bottom: 20px;
    padding-bottom: 0;

    display: flex;
    flex-wrap: wrap;
}

.styles_rightColumn__j7esI {
}

.styles_rightColumn__j7esI .styles_fileList__2xPJa {
    justify-content: flex-end;
}

/*.rightColumn .fileList .fileItem {*/
/*    !*justify-content: end;*!*/
/*    grid-column: 3;*/
/*}*/

.styles_fileItem__32C2\\+ {
    /*font-size: 14px;*/
    /*color: #333;*/
    padding: 8px 12px;
    border: 0.5px solid var(--dark-grey);
    border-radius: 2px;
    display: flex;
    align-items: center;
    grid-gap: 20px;
    background: #fff;

    width: 280px;

    position: relative;
}

.styles_closeWrapper__bE-yT {
    opacity: 0;
    transition: opacity 0.4s;
    position: absolute;
    top: -10px;
    right: -10px;
    width: 20px;
    height: 20px;
    display: flex;
}

.styles_fileItem__32C2\\+:hover .styles_closeWrapper__bE-yT,
.styles_action__lQGOh:hover .styles_closeWrapper__bE-yT {
    opacity: 1;
}

.styles_fileTypeContainer__rNRHv {
    position: relative;
}

.styles_fileTypeContainer__rNRHv > span:first-child {
    text-align: left;
    justify-content: flex-start;
    width: 27px;
    height: 33px;
}

.styles_fileTypeContainer__rNRHv > span:first-child svg {
    width: 99%;
    height: 99%;
}

.styles_fileType__sJh40 {
    border: 0.5px solid var(--dark-grey);
    border-radius: 2px;
    font-size: 16px;
    line-height: 16px;
    background: #fff;
    position: absolute;
    left: 2px;
    bottom: -2px;
    padding: 2px 2px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
}

.styles_fileItemInfo__oa0LK {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    text-wrap: nowrap;
}

.styles_fileItemName__82oy\\+ {
    font-size: 16px;
}

.styles_fileItemSubtitle__3qhN3 {
    color: var(--dark-grey);
    display: block;
    font-size: 14px;
    margin-top: 7px;
}

.styles_errorMessage__Ifxeh {
    color: var(--alert-color, #ff4444);
    font-size: 14px;
    margin: 0;
}

.styles_dropzone__bvqUe {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 80px 20px;
    /*min-height: 170px;*/
    flex: 1 1;
}

.styles_tableContainer__Q46f3 {
    width: 950px;
    margin: auto;
    height: auto;
    min-height: auto;
    background-color: rgba(240, 243, 247, 0.2);
    border: 0.5px solid #707070;
    border-radius: 3px;
    flex: 1 1;
    position: relative;
}

.styles_mainContainer__EG3in {
    max-height: calc(100vh - var(--header-height) - 80px);
    overflow-y: auto;
}

.styles_twoColumnLayout__xGVzJ {
    display: flex;
    gap: 20px;
    width: 100%;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: row;
    box-sizing: border-box;
}

.styles_parsedSection__eRXwh {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(33.333% - 10px);
    display: flex;
    flex-direction: column;
    gap: 30px;
    align-items: stretch;
    min-width: 0;
}

/*.rightColumn {*/
/*    flex: 0 0 calc(66.666% - 10px);*/
/*    align-self: stretch;*/
/*    margin-top: 0;*/
/*    min-width: 0;*/
/*    display: flex;*/
/*    flex-direction: column;*/
/*}*/

/*.rightColumn > section {*/
/*    flex: 1;*/
/*    display: flex;*/
/*    flex-direction: column;*/
/*}*/

.styles_dropzoneActionsContainer__MVdNU {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.styles_dropzoneActionsOuter__YoHTH {
    margin-top: 24px;
}

.styles_dropzoneActions__71grl {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    font-size: 16px;
    /*color: #7b848e;*/
}

.styles_dropzoneActions__71grl.styles_margin__2WqJW {
    margin-bottom: 40px;
}

.styles_dropzoneActionsRight__Yno8a {
    justify-content: flex-end;
}

.styles_dropDownTrigger__U05kq {
    height: 25px;
    width: 25px;
    color: var(--primary-color);
    --icon-stroke: 1.5px;
}

.styles_dropDownTrigger__U05kq,
.styles_aiDropDownTrigger__ft7dy {
    padding: 0;
    border-radius: 2px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.4s;
    grid-gap: 5px;
}

.styles_dropDownTrigger__U05kq:after {
    content: 'Add files, pick up tasks and more';
}

.styles_aiDropDownTrigger__ft7dy {
    padding: 0 4px;
    --icon-color-custom: var(--dark-grey);
}

.styles_dropDownTrigger__U05kq:hover,
.styles_dropDownTriggerOpen__Jo7cN,
.styles_aiDropDownTrigger__ft7dy:hover,
.styles_aiDropDownTriggerOpen__JMM\\+Q {
    background-color: var(--primary-color-light);
    color: var(--primary-color);
    --icon-color-custom: var(--primary-color);
}

.styles_dropdownMenuCustomRight__anKva {
    left: -50%;
}

.styles_action__lQGOh {
    display: flex;
    align-items: center;
    gap: 7px;

    border-radius: 2px;
    padding: 8px 12px;
    border: 0.5px solid var(--dark-grey);
    position: relative;
}

.styles_actionPlusIcon__sTE3X {
    --icon-stroke: 1.5px;
    --icon-color-custom: var(--dark-grey);
    height: 12px;
    width: 12px;
}

.styles_action__lQGOh:not(.styles_disabled__vRyDR) {
    cursor: pointer;
}

.styles_action__lQGOh input {
    display: none;
}

.styles_actionLabel__fNZwy {
    flex: 1 1;
}

.styles_action__lQGOh.styles_selectedAction__bIB3D {
    color: var(--primary-color);
    border-color: var(--primary-color);
    background: var(--primary-color-light);
    min-width: 280px;
}

.styles_categoriesWrapper__-OCdD {
    /*margin-top: var(--page-top-offset);*/
    /*min-height: 80vh;*/
}

.styles_header__OX-6F {
    font-family: var(--font-secondary);
    color: var(--primary-color-active);
    margin: 35px 0;
    font-size: 35px;
    font-weight: 700;
}

.styles_categories__sUYtU {
    width: 1380px;
    max-width: 100%;
    margin: 0 auto 40px;
}

.styles_grid__V4AkQ {
    display: grid;
    grid-template-columns: calc(100% - 200px) 200px;
    grid-gap: 40px;
}

.styles_grid__V4AkQ > div {
    position: relative;
    min-height: calc(100vh - var(--header-height));
}

.styles_content__Pcba\\+ > div {
    max-width: 100%;
}

/*.content > div:first-child {*/
/*    flex: 1;*/
/*}*/

/*h4 {*/
/*    color: var(--alert-color);*/
/*    font-weight: 700;*/
/*    margin: 0 auto;*/
/*}*/

.styles_wrapper__2sRMg {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    /*padding: 0 116px;*/
    margin: 40px auto 50px;
    grid-gap: 49px;
    width: 100%;
    padding-bottom: 60px;
}

.styles_popupContainer__lyD64 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: left;
    display: flex;
    padding-bottom: 120px;
    z-index: 90;
}

.styles_popup__a66pN {
    position: relative;
    padding: 36px 24px 24px;
    display: flex;
    flex-direction: column;
    width: 485px;
    border: 1px solid #707070;
    background: white;
    margin: auto;
}

.styles_popup__a66pN h4 {
    color: #000000;
    text-align: left;
    margin-left: 0;
}

.styles_popup__a66pN p {
    margin: 14px 0 0;
}

.styles_placehodler__osWiS {
    font-size: 35px;
    font-weight: 300;
}

.styles_popup__a66pN h4 {
    font-size: 20px;
}

.styles_popup__a66pN p {
    font-size: 20px;
    line-height: 26px;
}

.styles_close__bz3W6 {
    position: relative;
    top: -40px;
    right: -20px;
}

.styles_linearActivity__SMx5I {
    overflow: hidden;
    width: 100%;
    height: 2px;
    background-color: #e5e5e5;
    margin: 24px auto 0;
}

.styles_determinate__dya-A {
    position: relative;
    max-width: 100%;
    height: 100%;
    transition: width 500ms ease-out 1s;
    background-color: var(--primary-color);
}

.styles_indeterminate__z3qVL {
    position: relative;
    width: 100%;
    height: 100%;
}

.styles_indeterminate__z3qVL:before {
    content: '';
    position: absolute;
    height: 100%;
    background-color: var(--primary-color);
    animation: styles_indeterminate_first__rb8AR 1.5s infinite ease-out;
}

.styles_indeterminate__z3qVL:after {
    content: '';
    position: absolute;
    height: 100%;
    background-color: var(--primary-color-active);
    animation: styles_indeterminate_second__opKb6 1.5s infinite ease-in;
}

.styles_placeholder__t-ro- {
    font-weight: 300;
    font-size: 35px;
}

.styles_tableContainerPreview__PZR4F {
    /*border: 0.5px solid var(--dark-grey);*/
    padding: 20px;
    /*border-radius: 3px;*/
    position: relative;
}

.styles_title__3Sw\\+- {
    display: flex;
    align-items: center;
    grid-gap: 17px;
}

.styles_title__3Sw\\+- img {
    width: 24px;
}

.styles_dropdownMenuCustomWideRight__sRx00 {
    min-width: 340px;
    right: 0;
    left: auto;
}

@keyframes styles_indeterminate_first__rb8AR {
    0% {
        left: -100%;
        width: 100%;
    }

    100% {
        left: 100%;
        width: 10%;
    }
}

@keyframes styles_indeterminate_second__opKb6 {
    0% {
        left: -150%;
        width: 100%;
    }

    100% {
        left: 100%;
        width: 10%;
    }
}

.styles_grid__V4AkQ > div:last-child {
    max-height: calc(100vh - var(--header-height) - 108px);
}

.styles_grid__V4AkQ > div:last-child aside {
    top: calc(var(--header-height) + 240px) !important;
}

.styles_selectedFormPreviewActions__V5AGA {
    display: flex;
    justify-content: center;
    grid-gap: 40px;
    margin: 40px auto 0;
}

.styles_selectedFormPreviewActions__V5AGA > div {
    text-align: center;
}

.styles_selectedPreviewBox__vme6R {
    width: 150px;
    text-align: center;
    margin-bottom: 15px;
    background: #fff;
    border: 0.5px solid var(--dark-grey);
    color: var(--primary-color);
    padding: 10px;
}

.styles_selectedPreviewBox__vme6R img {
    width: 100px;
    display: block;
    margin: auto auto 9px auto;
}

.styles_selectedFormActions__bBZEn {
    display: flex;
    margin-top: 40px;
    grid-gap: 20px;
    justify-content: flex-end;
}

@media (max-height: 1200px) {
    .styles_container__s1Dxh {
        padding-bottom: 0;
        --page-top-offset: 16px;
    }

    /*.categories {*/
    /*    margin: 12px auto;*/
    /*}*/

    .styles_grid__V4AkQ > div:last-child {
        min-height: unset;
        max-height: calc(100vh - var(--header-height) - 108px);
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Workflows/styles.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,oCAAoC;IACpC,6BAA6B;IAC7B,eAAe;IACf,wCAAwC;IACxC,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb,oCAAoC;IACpC,0CAA0C;IAC1C,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qCAAqC;IACrC;;yBAEqB;IACrB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,yCAAyC;IACzC,kCAAkC;AACtC;;AAEA;;IAEI,yBAAyB;IACzB,kCAAkC;IAClC,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;IACjB,yCAAyC;IACzC,SAAS;IACT,mBAAmB;IACnB,iBAAiB;;IAEjB,aAAa;IACb,eAAe;AACnB;;AAEA;AACA;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,qCAAqC;AACrC,gCAAgC;AAChC,sBAAsB;AACtB,IAAI;;AAEJ;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,gBAAgB;;IAEhB,YAAY;;IAEZ,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,wBAAwB;IACxB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,SAAO;AACX;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,0CAA0C;IAC1C,2BAA2B;IAC3B,kBAAkB;IAClB,SAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,qDAAqD;IACrD,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,YAA8B;IAA9B,cAA8B;IAA9B,gCAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,oBAAoB;IACpB,YAAY;AAChB;;AAEA,iBAAiB;AACjB,sCAAsC;AACtC,2BAA2B;AAC3B,qBAAqB;AACrB,oBAAoB;AACpB,qBAAqB;AACrB,8BAA8B;AAC9B,IAAI;;AAEJ,2BAA2B;AAC3B,eAAe;AACf,qBAAqB;AACrB,8BAA8B;AAC9B,IAAI;;AAEJ;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;;IAEI,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;IACjC,aAAa;AACjB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,cAAc;IACd,qCAAqC;AACzC;;AAEA;;;;IAII,4CAA4C;IAC5C,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;;IAER,kBAAkB;IAClB,iBAAiB;IACjB,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,qCAAqC;IACrC,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,2BAA2B;IAC3B,kCAAkC;IAClC,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,kCAAkC;IAClC,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,+CAA+C;IAC/C,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,eAAe;AACnB;;AAEA,+BAA+B;AAC/B,eAAe;AACf,IAAI;;AAEJ,OAAO;AACP,iCAAiC;AACjC,wBAAwB;AACxB,sBAAsB;AACtB,IAAI;;AAEJ;IACI,aAAa;IACb,eAAe;IACf,2BAA2B;IAC3B,oBAAoB;IACpB,sBAAsB;IACtB,cAAc;IACd,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IAIZ,mCAAmC;IACnC,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,sCAAsC;IACtC,mEAAqD;AACzD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,6CAA6C;IAC7C,mEAAqD;AACzD;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,wCAAwC;IACxC,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI;QACI,WAAW;QACX,WAAW;IACf;;IAEA;QACI,UAAU;QACV,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;QACX,WAAW;IACf;;IAEA;QACI,UAAU;QACV,UAAU;IACd;AACJ;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,oCAAoC;IACpC,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI;QACI,iBAAiB;QACjB,uBAAuB;IAC3B;;IAEA,gBAAgB;IAChB,yBAAyB;IACzB,IAAI;;IAEJ;QACI,iBAAiB;QACjB,sDAAsD;IAC1D;AACJ","sourcesContent":[".container {\n    --page-top-offset: 46px;\n    display: flex;\n    flex-direction: column;\n    margin: var(--container-margin) auto;\n    width: var(--container-width);\n    max-width: 100%;\n    padding: 0 var(--container-padding) 60px;\n    /*max-height: calc(100vh - var(--header-height));*/\n}\n\n.content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: column;\n    /*padding: 0 0 60px;*/\n}\n\n.content .twoColumnLayout {\n    align-items: flex-start;\n    width: 100%;\n}\n\n.content h3 {\n    font-weight: 300;\n    font-size: 20px;\n}\n\n.dropzoneContainer {\n    display: flex;\n    padding: 22px 17px 22px;\n    flex-direction: column;\n    /*gap: 40px;*/\n    border: 0.5px solid var(--dark-grey);\n    background-color: rgba(240, 243, 247, 0.1);\n    width: 950px;\n    max-width: 100%;\n    border-radius: 3px;\n    box-sizing: border-box;\n    position: relative;\n}\n\n.dropzoneContainerWide {\n    min-height: 300px;\n    padding-bottom: 10px;\n}\n\n.dropzoneContainer.active {\n    background-color: rgba(240, 243, 247, 0.2);\n}\n\n.actionBtn {\n    position: absolute;\n    top: -17px;\n    right: -17px;\n    width: 34px;\n    height: 34px;\n    border-radius: 50%;\n    background: #fff;\n    border: 1px solid var(--dark-grey);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    --icon-color-custom: var(--dark-grey);\n    transition:\n        background-color 0.4s,\n        border-color 0.4s;\n    padding: 0;\n    z-index: 2;\n}\n\n.actionBtn.active {\n    --icon-color-custom: var(--primary-color);\n    border-color: var(--primary-color);\n}\n\n.actionBtn:hover,\n.actionBtn.active:hover {\n    --icon-color-custom: #fff;\n    border-color: var(--primary-color);\n    background-color: var(--primary-color);\n}\n\n.fileList {\n    /*display: grid;*/\n    /*grid-template-columns: repeat(3, 1fr);*/\n    gap: 16px;\n    margin-bottom: 20px;\n    padding-bottom: 0;\n\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.rightColumn {\n}\n\n.rightColumn .fileList {\n    justify-content: flex-end;\n}\n\n/*.rightColumn .fileList .fileItem {*/\n/*    !*justify-content: end;*!*/\n/*    grid-column: 3;*/\n/*}*/\n\n.fileItem {\n    /*font-size: 14px;*/\n    /*color: #333;*/\n    padding: 8px 12px;\n    border: 0.5px solid var(--dark-grey);\n    border-radius: 2px;\n    display: flex;\n    align-items: center;\n    grid-gap: 20px;\n    background: #fff;\n\n    width: 280px;\n\n    position: relative;\n}\n\n.closeWrapper {\n    opacity: 0;\n    transition: opacity 0.4s;\n    position: absolute;\n    top: -10px;\n    right: -10px;\n    width: 20px;\n    height: 20px;\n    display: flex;\n}\n\n.fileItem:hover .closeWrapper,\n.action:hover .closeWrapper {\n    opacity: 1;\n}\n\n.fileTypeContainer {\n    position: relative;\n}\n\n.fileTypeContainer > span:first-child {\n    text-align: left;\n    justify-content: flex-start;\n    width: 27px;\n    height: 33px;\n}\n\n.fileTypeContainer > span:first-child svg {\n    width: 99%;\n    height: 99%;\n}\n\n.fileType {\n    border: 0.5px solid var(--dark-grey);\n    border-radius: 2px;\n    font-size: 16px;\n    line-height: 16px;\n    background: #fff;\n    position: absolute;\n    left: 2px;\n    bottom: -2px;\n    padding: 2px 2px;\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);\n}\n\n.fileItemInfo {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n    text-wrap: nowrap;\n}\n\n.fileItemName {\n    font-size: 16px;\n}\n\n.fileItemSubtitle {\n    color: var(--dark-grey);\n    display: block;\n    font-size: 14px;\n    margin-top: 7px;\n}\n\n.errorMessage {\n    color: var(--alert-color, #ff4444);\n    font-size: 14px;\n    margin: 0;\n}\n\n.dropzone {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    padding: 80px 20px;\n    /*min-height: 170px;*/\n    flex: 1;\n}\n\n.tableContainer {\n    width: 950px;\n    margin: auto;\n    height: auto;\n    min-height: auto;\n    background-color: rgba(240, 243, 247, 0.2);\n    border: 0.5px solid #707070;\n    border-radius: 3px;\n    flex: 1;\n    position: relative;\n}\n\n.mainContainer {\n    max-height: calc(100vh - var(--header-height) - 80px);\n    overflow-y: auto;\n}\n\n.twoColumnLayout {\n    display: flex;\n    gap: 20px;\n    width: 100%;\n    align-items: flex-start;\n    justify-content: flex-start;\n    flex-direction: row;\n    box-sizing: border-box;\n}\n\n.parsedSection {\n    flex: 0 0 calc(33.333% - 10px);\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n    align-items: stretch;\n    min-width: 0;\n}\n\n/*.rightColumn {*/\n/*    flex: 0 0 calc(66.666% - 10px);*/\n/*    align-self: stretch;*/\n/*    margin-top: 0;*/\n/*    min-width: 0;*/\n/*    display: flex;*/\n/*    flex-direction: column;*/\n/*}*/\n\n/*.rightColumn > section {*/\n/*    flex: 1;*/\n/*    display: flex;*/\n/*    flex-direction: column;*/\n/*}*/\n\n.dropzoneActionsContainer {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.dropzoneActionsOuter {\n    margin-top: 24px;\n}\n\n.dropzoneActions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 15px;\n    font-size: 16px;\n    /*color: #7b848e;*/\n}\n\n.dropzoneActions.margin {\n    margin-bottom: 40px;\n}\n\n.dropzoneActionsRight {\n    justify-content: flex-end;\n}\n\n.dropDownTrigger {\n    height: 25px;\n    width: 25px;\n    color: var(--primary-color);\n    --icon-stroke: 1.5px;\n}\n\n.dropDownTrigger,\n.aiDropDownTrigger {\n    padding: 0;\n    border-radius: 2px;\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.4s;\n    grid-gap: 5px;\n}\n\n.dropDownTrigger:after {\n    content: 'Add files, pick up tasks and more';\n}\n\n.aiDropDownTrigger {\n    padding: 0 4px;\n    --icon-color-custom: var(--dark-grey);\n}\n\n.dropDownTrigger:hover,\n.dropDownTriggerOpen,\n.aiDropDownTrigger:hover,\n.aiDropDownTriggerOpen {\n    background-color: var(--primary-color-light);\n    color: var(--primary-color);\n    --icon-color-custom: var(--primary-color);\n}\n\n.dropdownMenuCustomRight {\n    left: -50%;\n}\n\n.action {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n\n    border-radius: 2px;\n    padding: 8px 12px;\n    border: 0.5px solid var(--dark-grey);\n    position: relative;\n}\n\n.actionPlusIcon {\n    --icon-stroke: 1.5px;\n    --icon-color-custom: var(--dark-grey);\n    height: 12px;\n    width: 12px;\n}\n\n.action:not(.disabled) {\n    cursor: pointer;\n}\n\n.action input {\n    display: none;\n}\n\n.actionLabel {\n    flex: 1;\n}\n\n.action.selectedAction {\n    color: var(--primary-color);\n    border-color: var(--primary-color);\n    background: var(--primary-color-light);\n    min-width: 280px;\n}\n\n.categoriesWrapper {\n    /*margin-top: var(--page-top-offset);*/\n    /*min-height: 80vh;*/\n}\n\n.header {\n    font-family: var(--font-secondary);\n    color: var(--primary-color-active);\n    margin: 35px 0;\n    font-size: 35px;\n    font-weight: 700;\n}\n\n.categories {\n    width: 1380px;\n    max-width: 100%;\n    margin: 0 auto 40px;\n}\n\n.grid {\n    display: grid;\n    grid-template-columns: calc(100% - 200px) 200px;\n    grid-gap: 40px;\n}\n\n.grid > div {\n    position: relative;\n    min-height: calc(100vh - var(--header-height));\n}\n\n.content > div {\n    max-width: 100%;\n}\n\n/*.content > div:first-child {*/\n/*    flex: 1;*/\n/*}*/\n\n/*h4 {*/\n/*    color: var(--alert-color);*/\n/*    font-weight: 700;*/\n/*    margin: 0 auto;*/\n/*}*/\n\n.wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    /*padding: 0 116px;*/\n    margin: 40px auto 50px;\n    grid-gap: 49px;\n    width: 100%;\n    padding-bottom: 60px;\n}\n\n.popupContainer {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    text-align: left;\n    display: flex;\n    padding-bottom: 120px;\n    z-index: 90;\n}\n\n.popup {\n    position: relative;\n    padding: 36px 24px 24px;\n    display: flex;\n    flex-direction: column;\n    width: 485px;\n    border: 1px solid #707070;\n    background: white;\n    margin: auto;\n}\n\n.popup h4 {\n    color: #000000;\n    text-align: left;\n    margin-left: 0;\n}\n\n.popup p {\n    margin: 14px 0 0;\n}\n\n.placehodler {\n    font-size: 35px;\n    font-weight: 300;\n}\n\n.popup h4 {\n    font-size: 20px;\n}\n\n.popup p {\n    font-size: 20px;\n    line-height: 26px;\n}\n\n.close {\n    position: relative;\n    top: -40px;\n    right: -20px;\n}\n\n.linearActivity {\n    overflow: hidden;\n    width: 100%;\n    height: 2px;\n    background-color: #e5e5e5;\n    margin: 24px auto 0;\n}\n\n.determinate {\n    position: relative;\n    max-width: 100%;\n    height: 100%;\n    -webkit-transition: width 500ms ease-out 1s;\n    -moz-transition: width 500ms ease-out 1s;\n    -o-transition: width 500ms ease-out 1s;\n    transition: width 500ms ease-out 1s;\n    background-color: var(--primary-color);\n}\n\n.indeterminate {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.indeterminate:before {\n    content: '';\n    position: absolute;\n    height: 100%;\n    background-color: var(--primary-color);\n    animation: indeterminate_first 1.5s infinite ease-out;\n}\n\n.indeterminate:after {\n    content: '';\n    position: absolute;\n    height: 100%;\n    background-color: var(--primary-color-active);\n    animation: indeterminate_second 1.5s infinite ease-in;\n}\n\n.placeholder {\n    font-weight: 300;\n    font-size: 35px;\n}\n\n.tableContainerPreview {\n    /*border: 0.5px solid var(--dark-grey);*/\n    padding: 20px;\n    /*border-radius: 3px;*/\n    position: relative;\n}\n\n.title {\n    display: flex;\n    align-items: center;\n    grid-gap: 17px;\n}\n\n.title img {\n    width: 24px;\n}\n\n.dropdownMenuCustomWideRight {\n    min-width: 340px;\n    right: 0;\n    left: auto;\n}\n\n@keyframes indeterminate_first {\n    0% {\n        left: -100%;\n        width: 100%;\n    }\n\n    100% {\n        left: 100%;\n        width: 10%;\n    }\n}\n\n@keyframes indeterminate_second {\n    0% {\n        left: -150%;\n        width: 100%;\n    }\n\n    100% {\n        left: 100%;\n        width: 10%;\n    }\n}\n\n.grid > div:last-child {\n    max-height: calc(100vh - var(--header-height) - 108px);\n}\n\n.grid > div:last-child aside {\n    top: calc(var(--header-height) + 240px) !important;\n}\n\n.selectedFormPreviewActions {\n    display: flex;\n    justify-content: center;\n    grid-gap: 40px;\n    margin: 40px auto 0;\n}\n\n.selectedFormPreviewActions > div {\n    text-align: center;\n}\n\n.selectedPreviewBox {\n    width: 150px;\n    text-align: center;\n    margin-bottom: 15px;\n    background: #fff;\n    border: 0.5px solid var(--dark-grey);\n    color: var(--primary-color);\n    padding: 10px;\n}\n\n.selectedPreviewBox img {\n    width: 100px;\n    display: block;\n    margin: auto auto 9px auto;\n}\n\n.selectedFormActions {\n    display: flex;\n    margin-top: 40px;\n    grid-gap: 20px;\n    justify-content: flex-end;\n}\n\n@media (max-height: 1200px) {\n    .container {\n        padding-bottom: 0;\n        --page-top-offset: 16px;\n    }\n\n    /*.categories {*/\n    /*    margin: 12px auto;*/\n    /*}*/\n\n    .grid > div:last-child {\n        min-height: unset;\n        max-height: calc(100vh - var(--header-height) - 108px);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__s1Dxh`,
	"content": `styles_content__Pcba+`,
	"twoColumnLayout": `styles_twoColumnLayout__xGVzJ`,
	"dropzoneContainer": `styles_dropzoneContainer__6uBNK`,
	"dropzoneContainerWide": `styles_dropzoneContainerWide__C0V5J`,
	"active": `styles_active__lgxyy`,
	"actionBtn": `styles_actionBtn__CzTzm`,
	"fileList": `styles_fileList__2xPJa`,
	"rightColumn": `styles_rightColumn__j7esI`,
	"fileItem": `styles_fileItem__32C2+`,
	"closeWrapper": `styles_closeWrapper__bE-yT`,
	"action": `styles_action__lQGOh`,
	"fileTypeContainer": `styles_fileTypeContainer__rNRHv`,
	"fileType": `styles_fileType__sJh40`,
	"fileItemInfo": `styles_fileItemInfo__oa0LK`,
	"fileItemName": `styles_fileItemName__82oy+`,
	"fileItemSubtitle": `styles_fileItemSubtitle__3qhN3`,
	"errorMessage": `styles_errorMessage__Ifxeh`,
	"dropzone": `styles_dropzone__bvqUe`,
	"tableContainer": `styles_tableContainer__Q46f3`,
	"mainContainer": `styles_mainContainer__EG3in`,
	"parsedSection": `styles_parsedSection__eRXwh`,
	"dropzoneActionsContainer": `styles_dropzoneActionsContainer__MVdNU`,
	"dropzoneActionsOuter": `styles_dropzoneActionsOuter__YoHTH`,
	"dropzoneActions": `styles_dropzoneActions__71grl`,
	"margin": `styles_margin__2WqJW`,
	"dropzoneActionsRight": `styles_dropzoneActionsRight__Yno8a`,
	"dropDownTrigger": `styles_dropDownTrigger__U05kq`,
	"aiDropDownTrigger": `styles_aiDropDownTrigger__ft7dy`,
	"dropDownTriggerOpen": `styles_dropDownTriggerOpen__Jo7cN`,
	"aiDropDownTriggerOpen": `styles_aiDropDownTriggerOpen__JMM+Q`,
	"dropdownMenuCustomRight": `styles_dropdownMenuCustomRight__anKva`,
	"actionPlusIcon": `styles_actionPlusIcon__sTE3X`,
	"disabled": `styles_disabled__vRyDR`,
	"actionLabel": `styles_actionLabel__fNZwy`,
	"selectedAction": `styles_selectedAction__bIB3D`,
	"categoriesWrapper": `styles_categoriesWrapper__-OCdD`,
	"header": `styles_header__OX-6F`,
	"categories": `styles_categories__sUYtU`,
	"grid": `styles_grid__V4AkQ`,
	"wrapper": `styles_wrapper__2sRMg`,
	"popupContainer": `styles_popupContainer__lyD64`,
	"popup": `styles_popup__a66pN`,
	"placehodler": `styles_placehodler__osWiS`,
	"close": `styles_close__bz3W6`,
	"linearActivity": `styles_linearActivity__SMx5I`,
	"determinate": `styles_determinate__dya-A`,
	"indeterminate": `styles_indeterminate__z3qVL`,
	"indeterminate_first": `styles_indeterminate_first__rb8AR`,
	"indeterminate_second": `styles_indeterminate_second__opKb6`,
	"placeholder": `styles_placeholder__t-ro-`,
	"tableContainerPreview": `styles_tableContainerPreview__PZR4F`,
	"title": `styles_title__3Sw+-`,
	"dropdownMenuCustomWideRight": `styles_dropdownMenuCustomWideRight__sRx00`,
	"selectedFormPreviewActions": `styles_selectedFormPreviewActions__V5AGA`,
	"selectedPreviewBox": `styles_selectedPreviewBox__vme6R`,
	"selectedFormActions": `styles_selectedFormActions__bBZEn`
};
export default ___CSS_LOADER_EXPORT___;
